"use client";
import { isHeroBanner, playVideo, stopVideo, videoStorage } from "@/events";
import { useEffect } from "react";

interface IUseVideoVisibilityProps {
  videoRef: React.RefObject<HTMLVideoElement | null>;
}

export const useVideoVisibility = ({ videoRef }: IUseVideoVisibilityProps) => {
  useEffect(() => {
    const videoElement = videoRef.current;
    const isHero = isHeroBanner(videoElement);
    if (isHero) return;
    if (!videoElement) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          // Если видео полностью невидимо (пересечение 0%)
          const lastVideoPlayed = videoStorage.get();
          if (entry.intersectionRatio === 0) {
            if (videoElement.played && lastVideoPlayed === videoElement.id) {
              stopVideo(videoElement);
            }
          } else {
            if (lastVideoPlayed === videoElement.id) {
              playVideo(videoElement);
            }
          }
        });
      },
      {
        threshold: [0], // Порог 0 означает "полностью невидим"
      }
    );

    observer.observe(videoElement);

    return () => {
      observer.unobserve(videoElement);
    };
  }, [videoRef]);
};

export default useVideoVisibility;
